var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramEftpos48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EFTPOS-Pictogram_48x48px_Current",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9.000000, 4.000000)",
    stroke: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9864253,2.28846154 C24.0788121,2.28846154 25.0677827,2.73123875 25.7836566,3.44711265 C26.4995305,4.16298656 26.9423077,5.15195714 26.9423077,6.24434389 L26.9423077,6.24434389 L26.9423077,35.2941176 C26.9423077,36.3865044 26.4995305,37.375475 25.7836566,38.0913489 C25.0677827,38.8072228 24.0788121,39.25 22.9864253,39.25 L22.9864253,39.25 L4.70588235,39.25 C3.61349561,39.25 2.62452502,38.8072228 1.90865112,38.0913489 C1.19277721,37.375475 0.75,36.3865044 0.75,35.2941176 L0.75,35.2941176 L0.75,6.24434389 C0.75,5.15195714 1.19277721,4.16298656 1.90865112,3.44711265 C2.62452502,2.73123875 3.61349561,2.28846154 4.70588235,2.28846154 L4.70588235,2.28846154 Z",
    id: "Rectangle",
    strokeWidth: 1.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 3.82692308,
    y: 5.36538462,
    width: 20.0384615,
    height: 20.0384615,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3269231,-8.01737163 L14.8410066,-5.5506216 C15.1764144,-5.22152861 15.3653846,-4.77137586 15.3653846,-4.30148161 L15.3653846,-4.30148161 L15.3653846,5.85431022 C15.3653846,6.32781931 15.1735045,6.78111828 14.8335481,7.11072485 L14.8335481,7.11072485 L12.3269231,9.54103649 L12.3269231,-8.01737163 Z",
    id: "Path-9",
    strokeWidth: 1.5,
    fill: "#FFCC00",
    transform: "translate(13.846154, 0.769231) rotate(-90.000000) translate(-13.846154, -0.769231) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "card",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 11.5384615,
    y: 9.23076923,
    width: 18.9230769,
    height: 12,
    rx: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6538462,9.23076923 L28.6615385,9.23076923 C29.655651,9.23076923 30.4615385,10.0366567 30.4615385,11.0307692 L30.4615385,19.4307692 C30.4615385,20.4248818 29.655651,21.2307692 28.6615385,21.2307692 L26.6538462,21.2307692 L26.6538462,21.2307692 L20.7692308,15.2307692 L26.6538462,9.23076923 Z",
    id: "focus",
    strokeWidth: 1.5,
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "brand",
    fill: "#FFFFFF",
    points: "15.2307692 11.5384615 16.6153846 12.9230769 15.2307692 14.3076923 13.8461538 12.9354241"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramEftpos48);
export default __webpack_public_path__ + "static/media/pictogramEFTPOS48.0bd5a9f7fecc69ad6a7ec9061b0f0581.svg";
export { ForwardRef as ReactComponent };